import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ProductOrderCompleteTemplate } from 'components/Templates'

const ProductOrderComplete: FC = () => {
  return (
    <Layout title={'完了 | アプリでの並び順'}>
      <ProductOrderCompleteTemplate />
    </Layout>
  )
}

export default ProductOrderComplete
